// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","link":"_3lo6l _36PPP _2AZKg"};